import moment from 'moment';

export function displayTime (time) {
    const momentTime = moment.utc(time).local();

    const hour = momentTime.format('h:mmA');
    const date = momentTime.format('D/MM/YY');

    if (moment().diff(momentTime, 'days') > 0) {
        return `${hour} on ${date}`;
    } else {
        return `Today at ${hour}`;
    }
}
